'use client';

import { Link, usePathname } from '@/app/(webapp)/_i18n/navigation';
import { LicensesMenuLabelEnum } from '@/app/(webapp)/_types';
import { useTranslations } from 'next-intl';
import {
    NAVIGATION_ACTIVE_ITEM_CLASS,
    NAVIGATION_ITEM_CLASS,
    NAVIGATION_LAST_ITEM_CLASS,
    NavigationDropDown,
} from '../navigation-dropdown';
import type { LicensesDropDownProps, LicensesMenuItem, LicensesRoute } from './interfaces';

const MENU_ITEMS: ReadonlyArray<{ id: LicensesMenuLabelEnum; translationKey: string; href: LicensesRoute }> = [
    { id: LicensesMenuLabelEnum.RUNNING, translationKey: 'licenses.running', href: '/licenses-running' },
    { id: LicensesMenuLabelEnum.EXPIRED, translationKey: 'licenses.expired', href: '/licenses-expired' },
];

export const LicensesDropDown = ({ callback, autoExpand }: LicensesDropDownProps) => {
    const t = useTranslations('Navigation');
    const pathname = usePathname();
    const getActiveMenuFromPath = (): LicensesMenuLabelEnum | undefined => {
        if (pathname.includes('/licenses-running')) return LicensesMenuLabelEnum.RUNNING;
        if (pathname.includes('/licenses-expired')) return LicensesMenuLabelEnum.EXPIRED;
        return undefined;
    };

    const activeMenuItem = getActiveMenuFromPath();
    const translateDynamicKey = t as (key: string) => string;

    const menuItems: LicensesMenuItem[] = MENU_ITEMS.map((item) => ({
        id: item.id,
        label: translateDynamicKey(item.translationKey),
        href: item.href,
    }));

    return (
        <NavigationDropDown
            label={t('licenses.label')}
            isActive={!!activeMenuItem}
            autoOpen={autoExpand && !!activeMenuItem}
            panelClassName="max-h-[440px] sm:max-h-[initial] overflow-y-auto"
        >
            {(close) =>
                menuItems.map((item, index, array) => (
                    <li key={item.id}>
                        <Link
                            className={`${activeMenuItem === item.id ? NAVIGATION_ACTIVE_ITEM_CLASS : `whitespace-nowrap ${NAVIGATION_ITEM_CLASS}`} ${index === array.length - 1 ? NAVIGATION_LAST_ITEM_CLASS : ''}`}
                            onClick={() => {
                                callback();
                                close();
                            }}
                            href={item.href}
                        >
                            <span>{item.label}</span>
                        </Link>
                    </li>
                ))
            }
        </NavigationDropDown>
    );
};
